export default {"src":"/_next/static/media/avatar.fbd83037.svg","height":325,"width":325,"blurWidth":0,"blurHeight":0};